module.exports = __webpack_public_path__ + "static/media/marketing_creatives.cd738e1f.svg";